import { createAsyncThunk } from '@reduxjs/toolkit';

import { buildSpendInsightsBody } from '../lib/buildSpendInsightsBody';
import { normalizeSpendProductsResponse } from '../lib/normalizeProductsResponse';

import type {
    SpendInsightsOrderBy,
    SpendInsightsRequestParams,
    SpendProductsResponseDto,
} from '../types/ReportSpendSummarySchema';
import type { ThunkConfig } from 'app/providers/StoreProvider/config/types';

export interface FetchSpendProductsParams extends SpendInsightsRequestParams {
    orderBy?: SpendInsightsOrderBy;
    page?: number;
}

export const fetchSpendProducts = createAsyncThunk<
    SpendProductsResponseDto,
    FetchSpendProductsParams,
    ThunkConfig<string>
>('reportSpendSummary/fetchSpendProducts', async (params, thunkApi) => {
    const { extra, rejectWithValue } = thunkApi;
    try {
        const { orderBy = '-total_spend', page = 1, ...filters } = params;
        const response = await extra.api.post<SpendProductsResponseDto>(
            '/v1/reports/spend-insights/products',
            buildSpendInsightsBody(filters, {
                orderBy,
                page,
                pageSize: 25,
            }),
        );
        return normalizeSpendProductsResponse(response.data);
    } catch {
        return rejectWithValue('error');
    }
});
